export default __webpack_public_path__ + "static/media/coloquio_BannerWeb_movil_4.010d2823.jpg";